module.exports = __webpack_public_path__ + "static/img_4281-9a9a762814ef7a6bad590c78e1571a02.webp";